import type { VerifiedCitation } from '../../contract'
import { fmtTime, shortId, speakerHue } from '../format'

interface Props { cite: VerifiedCitation; onOpen: (c: VerifiedCitation) => void; titles?: Map<string, string> }

/** A verified quote: click anywhere on it to land on the source line in the reader. */
export function Quote({ cite, onOpen, titles }: Props) {
  return (
    <button className="quote" data-testid="quote" data-line-id={cite.lineId} onClick={() => onOpen(cite)} title={`Open ${cite.lineId}`}>
      <span className="quote__text">“{cite.quote}”</span>
      <span className="quote__meta">
        {cite.speaker && <span className="quote__speaker" style={{ ['--hue' as string]: speakerHue(cite.speaker) }}>{cite.speaker}</span>}
        {cite.t !== null && <span className="quote__time mono">{fmtTime(cite.t)}</span>}
        {!cite.speaker && cite.t === null && <span className="quote__untimed">untimed line</span>}
        <span className="quote__src" title={titles?.get(cite.transcriptId) ?? cite.transcriptId}>{shortId(cite.transcriptId)}</span>
      </span>
    </button>
  )
}
